import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSort = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 17,
	viewBox: "0 0 16 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M10.3337 12.4111L8.00033 14.7445L5.66699 12.4111",
		stroke: "#ABB0B2",
		strokeWidth: 1.5,
		strokeLinecap: "square",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M10.3337 4.58887L8.00033 2.25553L5.66699 4.58887",
		stroke: "#EF4444",
		strokeWidth: 1.5,
		strokeLinecap: "square",
		strokeLinejoin: "round"
	})]
});
export default SvgSort;
